<template>
	<v-card>
        <v-container>
            <v-toolbar-title class="mb-4">Privacidade e Segurança</v-toolbar-title>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            label="E-mail"
                            v-model="value.email"
                            type="email"
                            autocomplete="off"
                            :rules="[ emailValido ]"
                            :hint="novo ? 'O irmão recebe neste e-mail o link para definir a senha' : undefined"
                            :persistent-hint="novo"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            :label="novo ? 'Senha (para irmão sem e-mail)' : 'Nova Senha'"
                            v-model="value.senha"
                            autocomplete="new-password"
                            required
                        >
                            <template #append-outer>
                                <v-progress-circular
                                    v-if="!novo && podeEnviarLink && isPending"
                                    indeterminate
                                    size="24"
                                    color="grey"
                                />
                                <v-icon
                                    v-else-if="!novo && podeEnviarLink"
                                    @click="confirmarEnviarLink"
                                    color="primary"
                                    aria-label="Enviar link de senha"
                                >
                                    mdi-email-lock
                                </v-icon>
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col v-if="!novo && intersectRoles(authModule.role, 'admin')">
                        <DialogoDeExclusao
                            v-model="mostraExclusao"
                            :on-excluir="excluirIrmao"
                            :nome="value.nomeCompleto"
                        >
                            <template #activator="{ on }">
                                <v-btn
                                    color="error"
                                    text
                                    v-on="on"
                                    :disabled="excluindo"
                                >
                                    <v-icon left>mdi-delete</v-icon>
                                    Excluir
                                </v-btn>
                            </template>
                        </DialogoDeExclusao>
                    </v-col>
                </v-row>
        </v-container>

        <DialogoDeConfirmacao ref="dialogoDeConfirmacao" titulo="Enviar link de senha?">
            Enviaremos para {{ value.email || 'o e-mail do irmão' }} um link para ele definir uma nova senha
        </DialogoDeConfirmacao>
    </v-card>
</template>

<script setup lang="ts">
import DialogoDeConfirmacao from '@/components/dialogos/DialogoDeConfirmacao.vue'
import { computed, defineComponent, ref } from 'vue'
import { InputIrmao } from 'common/types/Irmao'
import IrmaoService from '@/services/IrmaoService'
import ConviteService from '@/services/ConviteService'
import { alert, authModule, userModule } from '@/store'
import { useMutation } from '@tanstack/vue-query'
import DialogoDeExclusao from '@/components/dialogos/DialogoDeExclusao.vue'
import { intersectRoles } from '@/../common/shareds/sharedAuth'
import { emailValido } from '@/shareds/regras'
import { useRouter } from 'vue2-helpers/vue-router'

defineComponent({
	inheritAttrs: true,
})

const props = defineProps<{
	novo: boolean, 
	value: InputIrmao
}>()

const emit = defineEmits(['update:modelValue']);

const mostraExclusao = ref(false);

const dialogoDeConfirmacao = ref<InstanceType<typeof DialogoDeConfirmacao>>()

const podeEnviarLink = computed(() => !!userModule.currentUser?.secretarioDeInformatica
	|| intersectRoles(authModule.role, ['admin', 'admin-potencia', 'admin-loja']))

const { mutate: enviarLink, isPending } = useMutation({
	mutationFn: async () => {
		if (!props.value._id) throw new Error('Irmão não possui ID')

		return ConviteService.enviar(props.value._id)
	},
	onSuccess() {
		alert.setSuccess('Link de senha enviado')
	},
	onError(error) {
		alert.setError(error)
	}
})

async function confirmarEnviarLink() {
	const confirmado = await dialogoDeConfirmacao.value?.abrir()
	if (!confirmado) return

	enviarLink()
}

const router = useRouter()

const { mutateAsync: excluirIrmao, isPending: excluindo } = useMutation({
    mutationFn: () => IrmaoService.remove(props.value._id!),
    onSuccess() {
        alert.setSuccess('Irmão removido com sucesso')
        router.push({ name: 'home' })
    }
})
</script>